import { ZpayEvent } from '@common/log-manager';

import type { ZpayEventAction } from '../../type/common.type';

export const callZpayEvent = (action: ZpayEventAction) => {
  switch (action) {
    case 'reloadCart':
      ZpayEvent.reloadCart();
      break;
    case 'addCart':
      ZpayEvent.addCart();
      break;
  }
};
